import "antd/dist/antd.css";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";

import AddOpportunityModal from "components/cdv/AddOpportunityModal";
import SidebarLayout from "components/organisms/SidebarLayout";
import ReportDetailsTemplate from "components/templates/ReportDetailsTemplate";
import { FEED_TYPES } from "constants/feedTypes";
import { useGetSingleTeam } from "reactQuery/hooks/pages/useSidebarLayout";
import { AllInsightsPathname } from "routes/IntelligenceFeeds";
import { redirectIfTeamHasIntelligenceFeedsProduct } from "utils/redirect";

import { useStyles } from "./styles.js";
import CreateInsightModal from "../../components/cdv/CreateInsightModal";
import { toggleEditMode, toggleOverlay } from "../../stores/uiStore/actionTypes";

interface UnconnectedReportDetailsPageProps {
    feedType: string;
    isUpdatingEditOpportunity: boolean;
    reportId: number;
    toggleEditMode: Function;
    toggleOverlay: Function;
    teamId: number;
}

export const UnconnectedReportDetailsPage = ({
    feedType,
}: UnconnectedReportDetailsPageProps) => {
    const styles = useStyles();

    const { search } = useLocation();

    const teamIdParam = new URLSearchParams(search).get("team_id");
    const teamId = teamIdParam ? parseInt(teamIdParam) : null;

    const teamQuery = useGetSingleTeam(teamId);
    const team = teamQuery?.data;

    redirectIfTeamHasIntelligenceFeedsProduct(AllInsightsPathname, teamId);

    const body = (
        <div className={styles.reportDetailsBody}>
            <>
                <AddOpportunityModal />
                <CreateInsightModal />
                <ReportDetailsTemplate
                    feedType={feedType}
                    team={team}
                    teamId={teamId}
                />
            </>
        </div>
    );

    return (
        <div>
            <SidebarLayout content={body} />
        </div>
    );
};

const mapStateToProps = (state: any, props: any) => {
    return {
        feedType: FEED_TYPES.ALL_INSIGHTS,
    };
};

const ConnectedReportDetailsPage = connect(mapStateToProps, {
    toggleEditMode,
    toggleOverlay: toggleOverlay,
})(UnconnectedReportDetailsPage);

export default ConnectedReportDetailsPage;
